import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'Live Digital Menus';
const BASE_URL = 'https://livedigitalmenus.com';

export default function useDocumentTitle(title) {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : `${BASE_TITLE} — Digital Menu Boards for Restaurants`;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    const canonicalPath = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');
    link.setAttribute('href', `${BASE_URL}${canonicalPath}`);

    return () => { document.title = `${BASE_TITLE} — Digital Menu Boards for Restaurants`; };
  }, [title, pathname]);
}
